import InfoUser from './InfoUser'

export default InfoUser
